import { factoringHeader } from "@/constants/defaultHeader";
import { httpClient } from "@/services";

export default {
	state: {
		factoringData: [],
		factoringFilter: {},
		edite: { factoring: {}, notes_rows: [], payment_type: [] },

		factoringExportLink: null,
		factoringSettingsDefault: null,
		factoringSettings: null,
		factoringHeaders: [],
	},

	mutations: {
		updateFactoringSettingsAll(state, payload) {
			state.factoringSettings = state.factoringSettings.map(item => {
				item.settings = payload;
				return item;
			});
		},
		updateFactoringSettingsReset(state) {
			state.factoringSettings = state.factoringSettingsDefault.map(item => ({ ...item }));
		},
		updateFactoringExportLink(state, payload) {
			state.factoringExportLink = payload;
		},
		EDITE_ONE(state, payload) {
			state.edite = payload;
		},
		SET_FACTORING_LIST(state, payload) {
			const { rows, filter, settings } = payload;
			state.factoringData = [];
			state.factoringData = rows;
			state.factoringFilter = filter;

			if (settings && settings.length > 0) {
				state.factoringSettingsDefault = settings;
				state.factoringSettings = settings.map(item => ({ ...item }));
				state.factoringHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.factoringHeaders.push(item);
					}
				});
			} else {
				state.factoringSettingsDefault = factoringHeader;
				state.factoringSettings = factoringHeader.map(item => ({ ...item }));
				state.factoringHeaders = [];
				factoringHeader.map(item => {
					if (item.settings) {
						state.factoringHeaders.push(item);
					}
				});
			}
		},
		DELETE_FACTORING_ITEM(state, payload) {
			state.factoringData = state.factoringData.filter(e => e.id !== payload.id);
		},
		UPDATE(state, payload) {
			const find = state.factoringData.findIndex(e => e.id === payload.id);
			state.factoringData.splice(find, 1, payload);
		}
	},
	actions: {
		async onFactoringSettingsSave({ dispatch, state }) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post('/factoring/settings', { settings: state.factoringSettings });
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		onFactoringSettingsAll({ commit }, payload) {
			commit('updateFactoringSettingsAll', payload);
		},
		onFactoringSettingsReset({ commit }) {
			commit('updateFactoringSettingsReset');
		},
		async getFactoringExport({ commit, dispatch }, value) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post("/factoring/export", value);

				if (data) {
					commit('updateFactoringExportLink', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getFactoringLogs({ commit, dispatch }, payload) {
			const filters = payload?.filterModList;
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post("/factoring/list", filters);

				if (data) {
					commit('SET_FACTORING_LIST', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async editFactoringItem({ commit, dispatch }, payload) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get(`factoring/${ payload }/edit`);

				if (data) {
					commit('EDITE_ONE', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getFactoringListNew({ commit, dispatch }) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get(`/factoring`);

				if (data) {
					commit('SET_FACTORING_LIST', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async setFactoringItem({ dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post(`factoring`, payload);
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async delFactoringItem({ dispatch, commit }, payload) {
			const { id } = payload;
			dispatch("actionPreloader", true);
			try {
				await httpClient.delete(`factoring/${ id }`);
				commit('DELETE_FACTORING_ITEM', payload);
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async updateFactoringItem({ dispatch }, payload) {
			const { id } = payload;
			dispatch("actionPreloader", true);
			try {
				await httpClient.put(`factoring/${ id }`, payload);
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		factoringData: s => s.factoringData,
		edite: s => s.edite,
		factoringFilter: s => s.factoringFilter,
		factoringExportLink: s => s.factoringExportLink,
		factoringSettingsDefault: s => s.factoringSettingsDefault,
		factoringSettings: s => s.factoringSettings,
		factoringHeaders: s => s.factoringHeaders,
	},
};
